import { render, staticRenderFns } from "./live-auth.vue?vue&type=template&id=67927ddf&scoped=true&"
import script from "./live-auth.vue?vue&type=script&lang=js&"
export * from "./live-auth.vue?vue&type=script&lang=js&"
import style0 from "./live-auth.vue?vue&type=style&index=0&id=67927ddf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67927ddf",
  null
  
)

export default component.exports